import React from 'react';
import HubPageLayout from '../components/HubPageLayout';
import PinFrame from '../components/PinFrame';

// File a Complaint (10-01 mockup): "Submit a complaint." pin frame with an
// illustration on the left and one button per agency on the right, each
// opening that agency's complaint site in a new tab. Same four agencies,
// URLs and seal icons as the desktop ribbon's File a complaint panel
// (icons copied from apps/main-app/public/assets/images/agency-*.png).
//
// The mockup's illustration (hooded figure in an envelope on a monitor) is
// not in the repo; the hooded-figure photo from the Scammer Profile page
// stands in, cropped to the figure. Swap HERO when the licensed file lands.
const HERO = '/images/site/predator-profile/hacker.jpeg';

const AGENCIES = [
  { id: 'ic3', label: 'FBI / IC3', url: 'https://www.ic3.gov' },
  { id: 'ssa', label: 'SSA', url: 'https://www.ssa.gov/fraud/' },
  { id: 'irs', label: 'IRS', url: 'https://www.irs.gov/help/report-fraud' },
  { id: 'ftc', label: 'FTC', url: 'https://reportfraud.ftc.gov/' },
];

const FileAComplaintPage = () => (
  <HubPageLayout>
    <PinFrame title="Submit a complaint.">
      {/* ml-[38px]: content starts under the pentagon's bottom point. */}
      <div className="ml-[38px] grid grid-cols-1 gap-10 md:grid-cols-[1fr_1fr]">
        <img
          src={HERO}
          alt="A hooded figure behind a screen of code"
          className="h-[300px] w-full object-cover object-left"
        />

        <ul className="flex flex-col justify-between gap-5 py-1">
          {AGENCIES.map((a) => (
            <li key={a.id}>
              <a
                href={a.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 rounded-xl border-2 border-black bg-white px-4 py-3 text-lg text-black transition-colors hover:bg-gray-50"
                title={`File a complaint with ${a.label} (opens ${new URL(a.url).host})`}
              >
                <img
                  src={`/images/agencies/${a.id}.png`}
                  alt=""
                  className="h-9 w-9 flex-shrink-0 object-contain"
                />
                <span>{a.label}</span>
                <span aria-hidden="true" className="ml-auto text-gray-500">&rarr;</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </PinFrame>
  </HubPageLayout>
);

export default FileAComplaintPage;
